<template>
    <div>
        <div class="page-header pr-0">
            <h2>
                <a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active"><span>RECEPCIÓN</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <div class="btn-group flex-wrap">
                    <button
                        class="btn btn-custom btn-sm mt-2 mr-2"
                        type="button"
                        @click="onGotoBack"
                    >
                        <i class="fa fa-arrow-left"></i> Atras
                    </button>
                </div>
            </div>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">{{ title }}</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                        <ul class="list-group">
                            <li class="list-group-item active">Habitación</li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span>Habitación:</span>
                                <strong>{{ currentRent.room.name }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span>Tipo:</span>
                                <strong>{{ currentRent.room.category.description }}</strong>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <ul class="list-group">
                            <li class="list-group-item active">Cliente</li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span>Nombres:</span>
                                <strong>{{ currentRent.customer.name }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span># Documento:</span>
                                <strong>{{ currentRent.customer.number }}</strong>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <ul class="list-group">
                            <li class="list-group-item active">Entrada/Salida</li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span>Fecha/Hora Entrada:</span>
                                <strong
                                >{{ currentRent.input_date | toDate }} -
                                    {{ currentRent.input_time | toTime }}</strong
                                >
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span>Fecha/Hora Salida:</span>
                                <strong
                                >{{ currentRent.output_date | toDate }} -
                                    {{ currentRent.output_time | toTime }}</strong
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                <tr class="table-info">
                                    <th></th>
                                    <th colspan="5">Costo del alojamiento</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>#</td>
                                    <td>Costo por tarifa</td>
                                    <td>Cant. noches</td>
                                    <td>Carga por salir tarde</td>
                                    <td>Comprobante</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>{{ room.item.unit_price | toDecimals }}</td>
                                    <td>{{ room.item.quantity }}</td>
                                    <td class="text-center">
                                        <div class="d-d-inline-block"
                                             style="max-width: 120px">
                                            <el-input v-model="arrears"
                                                      type="number"></el-input>
                                        </div>
                                    </td>
                                    <td>
                                        {{ room.sale_note ? room.sale_note.series + '-' + room.sale_note.number : '' }}
                                    </td>
                                    <td class="text-center">
                                        <div class="d-d-inline-block"
                                             style="max-width: 120px">
                                            <el-input
                                                v-model="total"
                                                readonly
                                                type="number"
                                            ></el-input>
                                        </div>
                                    </td>
                                </tr>

                                <template v-if="itemsPaid.length">
                                    <tr class="table-info">
                                        <td></td>
                                        <td colspan="5"><strong>Servicio al cuarto (Pagado)</strong></td>
                                    </tr>
                                    <tr>
                                        <td>#</td>
                                        <td>Descripción</td>
                                        <td>Precio unitario</td>
                                        <td>Cantidad</td>
                                        <td>Comprobante</td>
                                        <td>Total</td>
                                    </tr>
                                    <tr
                                        v-for="(it, i) in itemsPaid"
                                        v-show="it.type === 'PRO'"
                                        :key="i"
                                    >
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ it.item.item.description }}</td>
                                        <td>{{ it.item.input_unit_price_value | toDecimals }}</td>
                                        <td>{{ it.item.quantity | toDecimals }}</td>
                                        <td>
                                            {{ it.sale_note ? it.sale_note.series + '-' + it.sale_note.number : '' }}
                                        </td>
                                        <td>{{ it.item.total | toDecimals }}</td>
                                    </tr>
                                </template>

                                <template v-if="itemsDebt.length">
                                    <tr class="table-danger">
                                        <td></td>
                                        <td colspan="5"><strong>Servicio al cuarto (Cargo Pendiente)</strong></td>
                                    </tr>
                                    <tr>
                                        <td>#</td>
                                        <td>Descripción</td>
                                        <td>Precio unitario</td>
                                        <td>Cantidad</td>
                                        <td>Estado</td>
                                        <td>Total</td>
                                    </tr>
                                    <tr
                                        v-for="(it, i) in itemsDebt"
                                        v-show="it.type === 'PRO'"
                                        :key="i"
                                    >
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ it.item.item.description }}</td>
                                        <td>{{ it.item.input_unit_price_value | toDecimals }}</td>
                                        <td>{{ it.item.quantity | toDecimals }}</td>
                                        <td>
                                            {{ it.payment_status === "PAID" ? "PAGADO" : "DEBE" }}
                                        </td>
                                        <td>{{ it.item.total | toDecimals }}</td>
                                    </tr>
                                </template>

                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td class="text-right"
                                            colspan="5">Pagado
                                        </td>
                                        <td>
                                            <h3 class="my-0">
                                                <span class="badge badge-pill badge-info">
                                                    {{ totalPaid | toDecimals }}
                                                </span>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right"
                                            colspan="5">Debe
                                        </td>
                                        <td>
                                            <h3 class="my-0">
                                                <span class="badge badge-pill badge-danger">
                                                    {{ totalDebt | toDecimals }}
                                                </span>
                                            </h3>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <template v-if="totalDebt || toDecimals">
                        <div class="col-12">
                            <div class="" style="display: flex; align-items: center;">
                                <h5><strong>Registro de pagos pendientes</strong></h5>
                                <div class="form-group ml-3">
                                    <label class="control-label">
                                        Serie
                                    </label>
                                    <el-select v-model="sale_note.series_id" placeholder="">
                                      <el-option v-for="serie in serieNv"
                                        :key="serie.id"
                                        :label="serie.number"
                                        :value="serie.id"
                                    ></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="table-responsive" style="overflow-x: auto;">
                                <table class="table table-peding">
                                    <thead>
                                        <tr>
                                            <th>M. Pago</th>
                                            <th>Destino</th>
                                            <th>Referencia</th>
                                            <th>Monto</th>
                                            <th width="15%">
                                                <a
                                                    class="text-center font-weight-bold text-info"
                                                    href="#"
                                                    @click.prevent="clickAddPaymentPending"
                                                >[+ Agregar]</a
                                                >
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in sale_note.payments"
                                        :key="index">
                                        <td>
                                            <div class="form-group mb-2 mr-2">
                                                <el-select v-model="row.payment_method_type_id">
                                                    <el-option
                                                        v-for="option in paymentMethodTypes"
                                                        :key="option.id"
                                                        :label="option.description"
                                                        :value="option.id"
                                                    ></el-option>
                                                </el-select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group mb-2 mr-2">
                                                <el-select
                                                    v-model="row.payment_destination_id"
                                                    filterable
                                                >
                                                    <el-option
                                                        v-for="option in paymentDestinations"
                                                        :key="option.id"
                                                        :label="option.description"
                                                        :value="option.id"
                                                    ></el-option>
                                                </el-select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group mb-2 mr-2">
                                                <el-input v-model="row.reference"></el-input>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group mb-2 mr-2">
                                                <el-input v-model="row.payment"></el-input>
                                            </div>
                                        </td>
                                        <td class="series-table-actions text-center">
                                            <button
                                                class="btn waves-effect waves-light btn-xs btn-danger"
                                                type="button"
                                                @click.prevent="clickRemovePaymentPending(index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                        <br/>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>

                    <el-divider />
                    <div class="col-12">
                        <h5>
                            <strong class="mr-2">Generar comprobante electrónico</strong>
                            <el-switch
                                v-model="generate_invoice"
                            ></el-switch>
                        </h5>
                    </div>

                    <template v-if="generate_invoice">
                        <div class="col-lg-3">
                            <div
                                :class="{ 'has-danger': errors.document_type_id }"
                                class="form-group"
                            >
                                <label class="control-label">Tipo comprobante</label>
                                <el-select
                                    v-model="document.document_type_id"
                                    class="border-left rounded-left border-info"
                                    dusk="document_type_id"
                                    popper-class="el-select-document_type"
                                    @change="changeDocumentType"
                                >
                                    <el-option
                                        v-for="option in document_types"
                                        :key="option.id"
                                        :label="option.description"
                                        :value="option.id"
                                    ></el-option>
                                </el-select>
                                <small
                                    v-if="errors.document_type_id"
                                    class="form-control-feedback"
                                    v-text="errors.document_type_id[0]"
                                ></small>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div :class="{ 'has-danger': errors.series_id }"
                                class="form-group">
                                <label class="control-label">Serie</label>
                                <el-select v-model="document.series_id">
                                    <el-option
                                        v-for="option in series"
                                        :key="option.id"
                                        :label="option.number"
                                        :value="option.id"
                                    ></el-option>
                                </el-select>
                                <small
                                    v-if="errors.series_id"
                                    class="form-control-feedback"
                                    v-text="errors.series_id[0]"
                                ></small>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div
                                :class="{ 'has-danger': errors.date_of_issue }"
                                class="form-group"
                            >
                                <label class="control-label">Fecha de emisión</label>
                                <el-date-picker
                                    v-model="document.date_of_issue"
                                    :clearable="false"
                                    readonly
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    @change="changeDateOfIssue"
                                ></el-date-picker>
                                <small
                                    v-if="errors.date_of_issue"
                                    class="form-control-feedback"
                                    v-text="errors.date_of_issue[0]"
                                ></small>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div
                                :class="{ 'has-danger': errors.date_of_issue }"
                                class="form-group"
                            >
                                <label class="control-label">Fecha de vencimiento</label>
                                <el-date-picker
                                    v-model="document.date_of_due"
                                    :clearable="false"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                                <small
                                    v-if="errors.date_of_due"
                                    class="form-control-feedback"
                                    v-text="errors.date_of_due[0]"
                                ></small>
                            </div>
                        </div>

                        <div class="col-12">
                            <table class="table">
                                <thead>
                                <tr width="100%">
                                    <th v-if="document.payments.length > 0">M. Pago</th>
                                    <th v-if="document.payments.length > 0">Destino</th>
                                    <th v-if="document.payments.length > 0">Referencia</th>
                                    <th v-if="document.payments.length > 0">Monto</th>
                                    <th width="15%">
                                        <a
                                            class="text-center font-weight-bold text-info"
                                            href="#"
                                            @click.prevent="clickAddPayment"
                                        >[+ Agregar]</a
                                        >
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in document.payments"
                                    :key="index">
                                    <td>
                                        <div class="form-group mb-2 mr-2">
                                            <el-select v-model="row.payment_method_type_id">
                                                <el-option
                                                    v-for="option in paymentMethodTypes"
                                                    :key="option.id"
                                                    :label="option.description"
                                                    :value="option.id"
                                                ></el-option>
                                            </el-select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group mb-2 mr-2">
                                            <el-select
                                                v-model="row.payment_destination_id"
                                                :disabled="row.payment_destination_disabled"
                                                filterable
                                            >
                                                <el-option
                                                    v-for="option in paymentDestinations"
                                                    :key="option.id"
                                                    :label="option.description"
                                                    :value="option.id"
                                                ></el-option>
                                            </el-select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group mb-2 mr-2">
                                            <el-input v-model="row.reference"></el-input>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group mb-2 mr-2">
                                            <el-input v-model="row.payment"></el-input>
                                        </div>
                                    </td>
                                    <td class="series-table-actions text-center">
                                        <button
                                            class="btn waves-effect waves-light btn-xs btn-danger"
                                            type="button"
                                            @click.prevent="clickCancel(index)"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                    <br/>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                    
                    <div class="col-12 pt-3">
                        <template v-if="canMakePayment">
                            <el-button
                                :disabled="loading"
                                :loading="loading"
                                type="primary"
                                @click="onGoToInvoice"
                            >
                                <i class="fa fa-save"></i>
                                <span class="ml-2">{{ labelBtnRegister }}</span>
                            </el-button>
                        </template>
                        <template v-else>
                            <!-- No debe dejar pagar si ya se finalizo el servicio -->
                            <!--
                            <el-button
                                :disabled="true"
                                type="primary"
                            >
                                <i class="fa fa-save"></i>
                                <span class="ml-2">Guardar y Generar Comprobante</span>
                            </el-button>
                            -->
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr class="table-danger">

                                        <th colspan="">
                                            Ya se finalizó el proceso.
                                            <el-button
                                                @click="onExitPage"
                                                type="primary"
                                            >
                                                <!-- <i class="fa fa-save"></i>-->
                                                <span class="ml-2">
                                                    Regresar
                                                </span>
                                            </el-button>
                                        </th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>


                        </template>
                    </div>
                </div>
            </div>
        </div>
        <document-options
            :isContingency="false"
            :recordId="documentNewId"
            :showClose="true"
            :showDialog.sync="showDialogDocumentOptions"
        >
            <template slot="more_options">
                <div class="row" v-if="external_id">
                    <div class="col-12">
                        <h5 style="font-size: 700;">Documento de pago pendiente: {{ numberFullSaleNote }}</h5>
                    </div>
                    <div class="col">
                        <a href="javascript:void(0)" class="btn mx-3 btn-primary btn-lg"
                            @click="clickTo('a4')"
                        >
                            <i class="far fa-file-pdf"></i>
                            <br>
                            <span>A4</span>
                        </a>
                    </div>
                    <div class="col" v-if="ShowTicket80">
                        <a href="javascript:void(0)" class="btn mx-3 btn-primary btn-lg"
                            @click="clickTo('ticket')"
                        >
                            <i class="far fa-file-pdf"></i>
                            <br>
                            <span>80mm</span>
                        </a>
                    </div>
                    <div class="col" v-if="ShowTicket58">
                        <a href="javascript:void(0)" class="btn mx-3 btn-primary btn-lg"
                            @click="clickTo('ticket_58')"
                        >
                            <i class="far fa-file-pdf"></i>
                            <br>
                            <span>58mm</span>
                        </a>
                    </div>
                    <div class="col" v-if="ShowTicket50">
                        <a href="javascript:void(0)" class="btn mx-3 btn-primary btn-lg"
                            @click="clickTo('ticket_50')"
                        >
                            <i class="far fa-file-pdf"></i>
                            <br>
                            <span>50mm</span>
                        </a>
                    </div>
                    <div class="col">
                        <a href="javascript:void(0)" class="btn btn-primary mx-3 btn-lg"
                            @click="clickTo('a5')"
                        >
                            <i class="far fa-file-pdf"></i>
                            <br>
                            <span>A5</span>
                        </a>
                    </div>
                </div>
            </template>
        </document-options>

        <sale-note-options :configuration="config"
                           :recordId="documentSaleNoteNewId"
                           :showClose="true"
                           :showDialog.sync="showDialogSaleNoteOptions">
        </sale-note-options>

    </div>
</template>

<script>
import moment from "moment";
import DocumentOptions from "@views/documents/partials/options.vue";
import SaleNoteOptions from "@views/sale_notes/partials/options.vue";
import {calculateRowItem} from "../../../../../../../resources/js/helpers/functions";
import {exchangeRate, functions} from "../../../../../../../resources/js/mixins/functions";
import {mapActions, mapState} from "vuex/dist/vuex.mjs";

export default {
    components: {
        DocumentOptions,
        SaleNoteOptions,
    },
    mixins: [
        exchangeRate,
        functions
    ],
    props: {
        rent: {
            type: Object,
            required: true,
        },
        customer: {
            type: Object,
            required: true,
        },
        room: {
            type: Object,
            required: true,
        },
        paymentMethodTypes: {
            type: Array,
            required: true,
        },
        paymentDestinations: {
            type: Array,
            required: true,
        },
        allSeries: {
            type: Array,
            required: true,
        },
        documentTypesInvoice: {
            type: Array,
            required: true,
        },
        configuration: {
            type: Object,
            required: false,
        },
        affectationIgvTypes: {
            type: Array,
            required: true,
        },
        serieNv: {
            type: Array,
        },
        productCharge: {
            type: Object
        }
    },
    computed: {
        ...mapState([
            'config',
        ]),
        canMakePayment: function () {
            if (
                this.currentRent !== undefined &&
                this.currentRent.status !== undefined &&
                this.currentRent.status !== 'FINALIZADO'
            ) {
                return true;
            }
            return false;
        },
        hasDebt()
        {
            return this.totalDebt > 0
        },

        itemsPaid() {
            return this.currentRent.items.filter(item => item.type === 'PRO' && item.payment_status === 'PAID')
        },

        itemsDebt() {
            return this.currentRent.items.filter(item => item.type === 'PRO' && item.payment_status === 'DEBT')
        },

        labelBtnRegister() {
            return this.generate_invoice ? 'Guardar y Generar Comprobante' : 'Guardar'
        },

        ShowTicket58: function () {
            if (this.config === undefined) return false;
            if (this.config == null) return false;
            if (this.config.show_ticket_58 === undefined) return false;
            if (this.config.show_ticket_58 == null) return false;
            if (
                this.config.show_ticket_58 !== undefined &&
                this.config.show_ticket_58 !== null) {
                return this.config.show_ticket_58;
            }
            return false;
        },
        ShowTicket80: function () {
            if (this.config === undefined) return false;
            if (this.config == null) return false;
            if (this.config.show_ticket_80 === undefined) return false;
            if (this.config.show_ticket_80 == null) return false;
            if (
                this.config.show_ticket_80 !== undefined &&
                this.config.show_ticket_80 !== null) {
                return this.config.show_ticket_80;
            }
            return false;
        },
        ShowTicket50: function () {
            if (this.config === undefined) return false;
            if (this.config == null) return false;
            if (this.config.show_ticket_50 === undefined) return false;
            if (this.config.show_ticket_50 == null) return false;
            if (
                this.config.show_ticket_50 !== undefined &&
                this.config.show_ticket_50 !== null) {
                return this.config.show_ticket_50;
            }
            return false;
        },
    },
    created() {
        this.loadConfiguration();
        this.$store.commit('setConfiguration', this.configuration);
        this.currentRent = this.rent
    },
    data() {
        return {
            title: "",
            currentRent: {},
            arrears: 0,
            total: 0,
            loading: false,
            totalPaid: 0,
            totalDebt: 0,
            response: {},
            document: {
                payments: [],
            },
            errors: {},
            series: [],
            document_types: [],
            all_document_types: [],
            resource_documents: "documents",
            showDialogDocumentOptions: false,
            documentNewId: null,
            form_cash_document: {},
            showDialogSaleNoteOptions: false,
            form: {
                establishment_id: null,
                date_of_issue: null
            },

            sale_note: {
                payments: [],
            },
            generate_invoice: false,
            external_id: null,
            print_ticket: null,
            print_ticket_58: null,
            print_ticket_50: null,
            print_a4: null,
            print_a5: null,
            documentSaleNoteNewId: null,
            numberFullSaleNote: null,

        };
    },
    async mounted() {
        // console.log(this.config);


        this.form.establishment_id = this.config.establishment.id;
        this.form.date_of_issue = moment().format("YYYY-MM-DD");
        await this.getPercentageIgv();

        this.room.item = await calculateRowItem(this.room.item, "PEN", 3, this.percentage_igv);

        this.initForm();
        await this.initDocument();
        this.all_document_types = this.documentTypesInvoice;
        this.title = `Checkout: Habitación ${this.currentRent.room.name}`;
        this.total = this.room.item.total;

        this.document.items = await this.currentRent.items.map((i) => {

            if(i.item.affectation_igv_type == undefined || _.isEmpty(i.item.affectation_igv_type))
            {
                i.item.affectation_igv_type = _.find(this.affectationIgvTypes, { id : i.item.affectation_igv_type_id })
            }

            return calculateRowItem(i.item, "PEN", 3, this.percentage_igv)
        });

        // console.log(this.document.items);
        await this.onCalculateTotals();
        // console.log(this.document);
        await this.onCalculatePaidAndDebts();
        await this.clickAddPayment()
        this.initFormSaleNote()
        this.clickAddPaymentPending()
        
        this.validateIdentityDocumentType();
        const date = moment().format("YYYY-MM-DD");
        await this.searchExchangeRateByDate(date).then((res) => {
            this.document.exchange_rate_sale = res;
        });

        // TODO: add sale_note information to the document
        let sale_notes_relateds = this.currentRent.items.reduce((obj, item) => {
            if (item.sale_note && item.sale_note_id) {
                const data =  {
                    number_full: `${item.sale_note.series}-${item.sale_note.number}`,
                    id: item.sale_note_id,
                    items: item.sale_note.items.map((i) => {
                            return {
                                id: item.sale_note_id,
                                item_id: i.item_id
                            }
                        })
                }
                const exists = obj.find(o => o.id === item.sale_note_id)
                if (!exists) {
                    obj.push(data)
                }
            }
            return obj
        }, [])
        
        this.document.sale_notes_relateds = sale_notes_relateds || null
    },
    watch: {
        arrears: {
            async handler(value) {
                console.log('arrears');
                if (isNaN(value)) {
                    return;
                }
                if (value >= 0) {
                    const total = parseFloat(this.room.item.total) + parseFloat(value);
                    this.total = total;
                    this.onCalculatePaidAndDebts();
    
                    this.recalculatePaymentsPending()
                }

                this.recalculatePayment()
            }
        }
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        validateIdentityDocumentType() {

            let identity_document_types = ["0", "1"];
            let customer = this.document.customer;

            if (
                identity_document_types.includes(customer.identity_document_type_id)
            ) {

                this.document_types = this.all_document_types.filter((row) => {
                    return ['03', '80'].includes(row.id)
                })

                // this.document_types = _.filter(this.all_document_types, { id: "03" });
            } else {
                this.document_types = this.all_document_types;
            }

            this.document.document_type_id =
                this.document_types.length > 0 ? this.document_types[0].id : null;
            this.changeDocumentType();
        },
        changeDateOfIssue() {
            this.document.date_of_due = this.document.date_of_issue;
        },
        changeDocumentType() {
            this.document.series_id = null;
            this.series = _.filter(this.allSeries, {
                document_type_id: this.document.document_type_id,
            });
            this.document.series_id =
                this.series.length > 0 ? this.series[0].id : null;
        },
        clickAddPayment(amount = null) {
            /** solucion a [object PointerEvent] */
            if (amount instanceof PointerEvent) {
                amount = null
            }
            const total = this.totalDebt + this.totalPaid
            const count = this.document.payments.length
            const newCount = count + 1
            const newAmount = parseFloat(parseFloat(total / newCount).toFixed(2))
            this.document.payments.forEach(p => {
                p.payment = newAmount
            })

            this.document.payments.push({
                id: null,
                document_id: null,
                date_of_payment: moment().format("YYYY-MM-DD"),
                payment_method_type_id: "01",
                payment_destination_id: 'cash', // null,
                reference: null,
                payment: newAmount,
            })

            const diference = Number((total - (newAmount * newCount)).toFixed(2))
            if (diference !== 0) {
                this.document.payments[this.document.payments.length - 1].payment += diference
            }
        },
        onExitPage() {
            window.location.href = "/hotels/reception";
        },
        validatePaymentDestination() {
            let error_by_item = 0;

            this.document.payments.forEach((item) => {
                if (item.payment_destination_id == null) error_by_item++;
            });

            return {
                error_by_item: error_by_item,
            };
        },
        validateTotalPayments()
        {
            // const total_payments = _.sumBy(this.document.payments, 'payment')
            const total_payments = parseFloat(this.document.payments.reduce((total, item) => total + (item.payment), 0).toFixed(2))
            if(total_payments > parseFloat(this.totalDebt + this.totalPaid)) return this.getResponseValidations(false, 'El total de los pagos agregados es superior al monto total.')
            
            return this.getResponseValidations()
        },
        initForm() {
            this.form_cash_document = {
                document_id: null,
                sale_note_id: null,
            };
        },
        updateDataForSend() {
            console.log('updateDataForSend');

            if (this.document.document_type_id === '80') {
                this.document.prefix = 'NV'
                this.resource_documents = 'sale-notes'
            } else {
                this.document.prefix = null
                this.resource_documents = 'documents'
            }

        },
        successGoToInvoice() {
            console.log('successGoToInvoice');

            //inicializa form_cash_document
            this.initForm()

            if (this.document.document_type_id === '80') //NV
            {
                this.form_cash_document.sale_note_id = this.documentNewId
                this.showDialogSaleNoteOptions = true

            } else {
                this.form_cash_document.document_id = this.documentNewId
                this.showDialogDocumentOptions = true;
            }

        },
        async onGoToInvoice() {
            let validate_payment_destination = this.validatePaymentDestination();

            if (validate_payment_destination.error_by_item > 0) {
                return this.$message.error("El destino del pago es obligatorio");
            }

            const validate_total_payments = this.validateTotalPayments()
            if(!validate_total_payments.success) return this.$message.error(validate_total_payments.message)

            this.loading = true

            /**
            * TODO: INICIO - REGISTRAR NV DE MONTOS "DEBE"
            */
            if (this.totalDebt > 0) {
                this.sale_note.items = this.currentRent.items.filter(item => item.payment_status === 'DEBT')
                                        .map(item => item.item)
                this.addLateCheckoutCharge()
                
                await this.saveSaleNote()
            }

            if (this.generate_invoice) {

                const main_address = this.currentRent.customer.address_main || null
                if (main_address) {
                    this.document.customer_address_id = main_address
                } else {
                    const address = this.currentRent.customer.addresses.filter(address => address.main)
                    this.document.customer_address_id = address.length ? address[0].id : null
                }

                // console.log('onGoToInvoice');
                await this.onUpdateItemsWithExtras();
                await this.onCalculateTotals();

                this.updateDataForSend()
                this.document.type_device = 'web'
                this.loading = true

                this.$http
                    .post(`/${this.resource_documents}`, this.document)
                    .then(async (response) => {
                        if (response.data.success) {

                            this.documentNewId = response.data.data.id;
                            this.successGoToInvoice()

                            this.$emit("update:showDialog", false);

                            if (this.resource_documents === 'sale-notes') {
                                this.form_cash_document.sale_note_id = response.data.data.id
                                this.form_cash_document.document_id = null
                            } else {
                                this.form_cash_document.document_id = response.data.data.id
                                this.form_cash_document.sale_note_id = null
                            }
                            this.form_cash_document.cash_id = response.data.data.cash_id
                            // this.saveCashDocument();

                            // REMOVE vacateRoom()

                                // const payloadFinalizedRent = {
                                //     arrears: this.arrears,
                                // };
                                // this.loading = true;
                                // this.$http
                                //     .post(
                                //         `/hotels/reception/${this.currentRent.id}/rent/finalized`,
                                //         payloadFinalizedRent
                                //     )
                                //     .then((responseFinalize) => {
                                //         this.response = response.data;
                                //         this.currentRent = responseFinalize.data.currentRent
                                //     })
                                //     .finally(() => {
                                //         this.loading = false
                                //     });
                            await this.vacateRoom()

                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data;
                        } else {
                            this.$message.error(error.response.data.message);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (!this.totalDebt) {
                await this.vacateRoom(true)
            }

            
        },
        onUpdateItemsWithExtras() {
            console.log('onUpdateItemsWithExtras');
            // modifica nombre del servicio de habitacion, para el documento final
            this.document.items = this.document.items.map((it) => {
                if (it.item_id === this.room.item_id) {
                    const name = `${this.room.item.item.description} x ${this.room.item.quantity} noche(s)`;
                    it.item.description = name;
                    it.item.full_description = name;
                    it.name_product_pdf = name;
                    it.quantity = 1;
                    const newTotal =
                        parseFloat(this.room.item.total)// + parseFloat(this.arrears);
                    console.log(newTotal);
                    it.input_unit_price_value = parseFloat(newTotal);
                    it.item.unit_price = parseFloat(newTotal);
                    it.unit_value = parseFloat(newTotal);
                    const newItem = calculateRowItem(it, "PEN", 3, this.percentage_igv);
                    return newItem;
                }
                return it;
            });
        },
        // async getItemsForSaleNote()
        // {
        //   return await this.$http.post(`/sale-notes/items-by-ids`, { ids : _.map(this.document.items, 'item_id')})
        // },
        saveCashDocument() {
            this.$http
                .post(`/cash/cash_document`, this.form_cash_document)
                .then((response) => {
                    if (!response.data.success) {
                        this.$message.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.axiosError(error);
                });
        },
        onCalculatePaidAndDebts() {
            this.totalPaid = this.currentRent.items
                .map((i) => {
                    if (i.payment_status === "PAID") {
                        return i.item.total;
                    }
                    return 0;
                })
                .reduce((a, b) => a + b, 0);
            const totalDebt = this.currentRent.items
                .map((i) => {
                    if (i.payment_status === "DEBT") {
                        return i.item.total;
                    }
                    return 0;
                })
                .reduce((a, b) => a + b, 0);
            this.totalDebt = totalDebt + parseFloat(this.arrears);
        },
        initDocument() {
            this.document = {
                customer_id: this.currentRent.customer_id,
                customer: this.currentRent.customer,
                document_type_id: null,
                series_id: null,
                prefix: null,
                establishment_id: this.config.establishment.id,
                number: "#",
                date_of_issue: moment().format("YYYY-MM-DD"),
                time_of_issue: moment().format("HH:mm:ss"),
                currency_type_id: "PEN",
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                total: 0,
                operation_type_id: "0101",
                date_of_due: moment().format("YYYY-MM-DD"),
                delivery_date: moment().format("YYYY-MM-DD"),
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                additional_information: null,
                actions: {
                    format_pdf: "a4",
                },
                dispatch_id: null,
                dispatch: null,
                is_receivable: false,
                payments: [],
                hotel: {},
                sale_notes_relateds: null,
                customer_address_id: null,
                source_module: 'HOTEL_CHECKOUT',
            };
        },
        onGotoBack() {
            window.location.href = "/hotels/reception";
        },
        clickCancel(index) {
            this.document.payments.splice(index, 1);

            const total = this.totalDebt + this.totalPaid
            const count = this.document.payments.length
            if (count === 0) return
            const newAmount = parseFloat(parseFloat(total / count).toFixed(2))
            this.document.payments.forEach(p => {
                p.payment = newAmount
            })
            const diference = Number((total - (newAmount * count)).toFixed(2))
            if (diference !== 0) {
                this.document.payments[this.document.payments.length - 1].payment += diference
            }
        },
        onCalculateTotals() {
            console.log('onCalculateTotals');
            console.log(this.percentage_igv);
            let total_exportation = 0;
            let total_taxed = 0;
            let total_exonerated = 0;
            let total_unaffected = 0;
            let total_free = 0;
            let total_igv = 0;
            let total_value = 0;
            let total = 0;
            let total_plastic_bag_taxes = 0;
            let total_discount = 0;
            let total_charge = 0;
            this.document.items.forEach((row) => {
                total_discount += parseFloat(row.total_discount);
                total_charge += parseFloat(row.total_charge);

                if (row.affectation_igv_type_id === "10") {
                    total_taxed += parseFloat(row.total_value);
                }

                if (row.affectation_igv_type_id === '20') {
                    total_exonerated += parseFloat(row.total_value)
                }

                if (["10", "20", "30", "40"].indexOf(row.affectation_igv_type_id) < 0) {
                    total_free += parseFloat(row.total_value);
                }

                if (
                    ["10", "20", "30", "40"].indexOf(row.affectation_igv_type_id) > -1
                ) {
                    total_igv += parseFloat(row.total_igv);
                    total += parseFloat(row.total);
                }

                total_value += parseFloat(row.total_value);
                total_plastic_bag_taxes += parseFloat(row.total_plastic_bag_taxes);

                if (["13", "14", "15"].includes(row.affectation_igv_type_id)) {
                    let unit_value =
                        row.total_value / row.quantity / (1 + this.percentage_igv / 100);
                    let total_value_partial = unit_value * row.quantity;
                    row.total_taxes = row.total_value - total_value_partial;
                    row.total_igv = row.total_value - total_value_partial;
                    row.total_base_igv = total_value_partial;
                    total_value -= row.total_value;
                }
            });

            this.document.total_exportation = _.round(total_exportation, 2);
            this.document.total_taxed = _.round(total_taxed, 2);
            this.document.total_exonerated = _.round(total_exonerated, 2);
            this.document.total_unaffected = _.round(total_unaffected, 2);
            this.document.total_free = _.round(total_free, 2);
            this.document.total_igv = _.round(total_igv, 2);
            this.document.total_value = _.round(total_value, 2);
            this.document.total_taxes = _.round(total_igv, 2);
            this.document.total_plastic_bag_taxes = _.round(
                total_plastic_bag_taxes,
                2
            );
            this.document.total = _.round(
                total + this.document.total_plastic_bag_taxes,
                2
            );
        },

        clickRemovePaymentPending(index) {
            this.sale_note.payments.splice(index, 1)
            this.recalculatePaymentsPending()
        },

        recalculatePaymentsPending() {
            const count = this.sale_note.payments.length
            if (count === 0) return
            const newAmount = parseFloat(parseFloat(this.totalDebt / count).toFixed(2))
            this.sale_note.payments.forEach(p => {
                p.payment = newAmount
            })
            const diference = Number((this.totalDebt - (newAmount * count)).toFixed(2))
            if (diference !== 0) {
                this.sale_note.payments[this.sale_note.payments.length - 1].payment += diference
            }
        },

        initFormSaleNote() {
            this.sale_note = {
                // serie_id: this.series.length ? this.series[0].id : null,
                document_type_id: '80',

                id: null,
                series_id: this.serieNv.length ? this.serieNv[0].id : null,
                prefix: 'NV',
                establishment_id: this.form.establishment_id,
                due_date: null,
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                customer_id: this.currentRent ? this.currentRent.customer_id : null,
                currency_type_id: this.config.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                subtotal: 0,
                total_igv_free: 0,
                total: 0,
                operation_type_id: null,
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payments: [],
                additional_information: null,
                actions: {
                    format_pdf: 'a4',
                },
                apply_concurrency: false,
                type_period: null,
                quantity_period: 0,
                automatic_date_of_issue: null,
                enabled_concurrency: false,
                license_plate: null,
                payment_method_type_id: null,
                paid: false,
                observation: null,
                terms_condition: null,

                type_device: 'web',

                dcto_monto_input: 0,
                dcto_totales_input: 0,
                monto_pagar_sin_dcto: 0,
                address_id: null,
                source_module: 'HOTEL_CHECKOUT',
            }
            // this.clickAddPaymentPending()
        },

        clickAddPaymentPending() {
            const currentCount = this.sale_note.payments.length
            const newCount = currentCount + 1
            const newAmount = parseFloat(parseFloat(this.totalDebt / newCount).toFixed(2))
            // Recalcular montos anteriores para distribuir equitativamente
            this.sale_note.payments.forEach(p => {
                p.payment = newAmount
            })

            this.sale_note.payments.push({
                id: null,
                document_id: null,
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: '01', // método de pago
                reference: null, // referencia
                payment_destination_id: 'cash', // this.getPaymentDestinationId(), // destino
                payment: newAmount, // 0,

                filename: null,
                temp_path: null,
                file_list: [],
            })

            const diference = Number((this.totalDebt - (newAmount * newCount)).toFixed(2))
            if (diference !== 0) {
                this.sale_note.payments[this.sale_note.payments.length - 1].payment += diference
            }
        },

        calculateTotalSaleNote() {
            let total_discount = 0
            let total_charge = 0
            let total_exportation = 0
            let total_taxed = 0
            let total_exonerated = 0
            let total_unaffected = 0
            let total_free = 0
            let total_igv = 0
            let total_value = 0
            let total = 0
            let total_igv_free = 0

            this.sale_note.items.forEach((row) => {
                total_discount += row.total_discount ? parseFloat(row.total_discount) : 0
                total_charge += parseFloat(row.total_charge)

                if (row.affectation_igv_type_id === '10') {
                    total_taxed += parseFloat(row.total_value)
                }
                if (row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
                    || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
                ) {
                    total_exonerated += parseFloat(row.total_value)
                }
                if (
                    row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
                    || row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
                    || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
                    || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
                    || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
                    || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
                    || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
                    || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
                ) {
                    total_unaffected += parseFloat(row.total_value)
                }
                if (row.affectation_igv_type_id === '40') {
                    total_exportation += parseFloat(row.total_value)
                }
                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) < 0) {
                    total_free += parseFloat(row.total_value)
                }
                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) > -1) {
                    total_igv += parseFloat(row.total_igv)
                    total += parseFloat(row.total)
                }


                if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {

                    let unit_value = row.total_value / row.quantity
                    let total_value_partial = unit_value * row.quantity
                    row.total_taxes = row.total_value - total_value_partial

                    row.total_igv = total_value_partial * (row.percentage_igv / 100)
                    row.total_base_igv = total_value_partial
                    total_value -= row.total_value

                    total_igv_free += row.total_igv
                }

                total_value += parseFloat(row.total_value)

            })

            this.sale_note.total_igv_free = _.round(total_igv_free, 2)

            this.sale_note.total_discount = _.round(total_discount, 2)
            this.sale_note.total_exportation = _.round(total_exportation, 2)
            this.sale_note.total_taxed = _.round(total_taxed, 2)
            this.sale_note.total_taxed_without_rounding = _.round(total_taxed, 5)
            this.sale_note.total_exonerated = _.round(total_exonerated, 2)
            this.sale_note.total_unaffected = _.round(total_unaffected, 2)
            this.sale_note.total_free = _.round(total_free, 2)
            this.sale_note.total_igv = _.round(total_igv, 2)
            this.sale_note.total_value = _.round(total_value, 2)
            this.sale_note.total_taxes = _.round(total_igv, 2)

            this.sale_note.subtotal = _.round(total, 2)
            this.sale_note.total = _.round(total, 2)

            // this.monto_pagar_sin_dcto = this.sale_note.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
            this.sale_note.monto_pagar_sin_dcto = this.sale_note.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
        },

        async saveSaleNote() {
            this.calculateTotalSaleNote()

            const main_address = this.currentRent.customer.address_main || null
            if (main_address) {
                this.sale_note.address_id = main_address
            } else {
                const address = this.currentRent.customer.addresses.filter(address => address.main)
                this.sale_note.address_id = address.length ? address[0].id : null
            }
            
            try {
                const response = await this.$http.post(`/sale-notes`, this.sale_note)
                if (response.data.success) {
                    const { id, cash_id, number_full, external_id } = response.data.data
                    // this.saleNotesNewId = id
                    // this.showDialogOptions = true
                    this.$message({
                        message: 'Nota de venta guardada correctamente',
                        type: 'success',
                    })
                    await this.saveCashDocumentSaleNote(id, cash_id)

                    if (!this.generate_invoice) {
                        this.documentSaleNoteNewId = id
                        this.showDialogSaleNoteOptions = true
                        await this.vacateRoom()
                    } else {
                        const related = {
                            number_full,
                            id,
                            items: this.sale_note.items.map(item => {
                                return {
                                    id,
                                    item_id: item.item_id
                                }
                            })
                        }

                        this.numberFullSaleNote = number_full
                        this.external_id = external_id
                        this.document.sale_notes_relateds.push(related)
                    }
                } else {
                    console.log('Error al guardar nota de venta')    
                }
                
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },

        async saveCashDocumentSaleNote(documentId, cashId) {
            const response = await this.$http.post(`/cash/cash_document`, {
                document_id: null,
                sale_note_id: documentId,
                cash_id: cashId,
            })
        },

        addLateCheckoutCharge() {
            const storage_establishment = JSON.parse(localStorage.getItem('establishment'))
            // let factor_bi = 1.18
            // let factor_igv = 0.18
            // let percentage_igv = 18
            let factor = this.percentage_igv
            let factor_bi = 1 + factor
            let factor_igv = factor
            let percentage_igv = this.percentage_igv * 100
            // if (storage_establishment.has_igv_31556) {
            //     factor_bi = 1.10
            //     factor_igv = 0.1
            //     percentage_igv = 10
            // }
            const find = this.sale_note.items.find(i => i.item_id === this.productCharge.id)

            if (parseFloat(this.arrears) === 0) {
                this.sale_note.items = this.sale_note.items.filter(item => item.item_id !== this.productCharge.id)
            } else {
                const item = {
                    affectation_igv_type: this.productCharge.sale_affectation_igv_type,
                    affectation_igv_type_id: this.productCharge.sale_affectation_igv_type_id,
                    attributes: [],
                    charges: [],
                    discounts: [],
                    input_unit_price_value: parseFloat(this.arrears), // colocar el valor del cargo por salir tarde
                    is_registered: false,
                    item: this.productCharge,
                    item_id: this.productCharge.id,
                    name_product_pdf: this.productCharge.name_product_pdf,
                    payment_status: 'DEBT',
                    percentage_igv: percentage_igv, // poner el de la config
                    percentage_isc: 0,
                    percentage_other_taxes: 0,
                    price_type_id: '01',
                    quantity: 1,
                    rent_payment: {}, // FIXME: ver
                    sale_note: null,
                    system_isc_type_id: null,
                    total: parseFloat(this.arrears), // colocar el valor del cargo por salir tarde
                    total_base_igv: Number((parseFloat(this.arrears) / factor_bi).toFixed(2)),
                    total_base_isc: 0,
                    total_base_other_taxes: 0,
                    total_charge: 0,
                    total_discount: 0,
                    total_igv: Number(((parseFloat(this.arrears) / factor_bi) * factor_igv).toFixed(2)),
                    total_isc: 0,
                    total_original: parseFloat(this.arrears), // colocar el valor del cargo por salir tarde
                    total_other_taxes: 0,
                    total_plastic_bag_taxes: 0,
                    total_taxes: Number(((parseFloat(this.arrears) / factor_bi) * factor_igv).toFixed(2)),
                    total_value: Number((parseFloat(this.arrears) / factor_bi).toFixed(2)),
                    unit_price: parseFloat(this.arrears),
                    unit_value: parseFloat(this.arrears) / factor_bi,
                    warehouse_id: null
                }

                
                if (find) {
                    find.input_unit_price_value = parseFloat(this.arrears)
                    find.total = parseFloat(this.arrears)
                    find.total = parseFloat(this.arrears)
                    find.total_base_igv = Number((parseFloat(this.arrears) / factor_bi).toFixed(2))
                    find.total_igv = Number(((parseFloat(this.arrears) / factor_bi) * factor_igv).toFixed(2))
                    find.total_original = parseFloat(this.arrears)
                    find.total_taxes = Number(((parseFloat(this.arrears) / factor_bi) * factor_igv).toFixed(2))
                    find.total_value = Number((parseFloat(this.arrears) / factor_bi).toFixed(2))
                    find.unit_price = parseFloat(this.arrears)
                    find.unit_value = parseFloat(this.arrears) / factor_bi
                } else {
                    this.sale_note.items.push(item)
                }

                //agregando servicio de cargo por salir tarde como item para documento final
                if (this.generate_invoice) {
                    this.document.items.push(item)
                }
            }

            
        },

        async vacateRoom(finalized = false) {
            this.loading = true
            const payloadFinalizedRent = {
                arrears: this.arrears,
            }
            try {
                const response = await this.$http.post(`/hotels/reception/${this.currentRent.id}/rent/finalized`,
                                    payloadFinalizedRent)
                this.currentRent = response.data.currentRent
                if (finalized) {
                    this.$message.success(response.data.message)
                }
            } finally {
                this.loading = false
            }
        },

        recalculatePayment() {
            const count = this.document.payments.length
            const payment = this.totalDebt + this.totalPaid
            if (count === 0) return
            const newAmount = parseFloat(parseFloat(payment / count).toFixed(2))
            this.document.payments.forEach(p => {
                p.payment = newAmount
            })
            const diference = Number((payment - (newAmount * count)).toFixed(2))
            if (diference !== 0) {
                this.document.payments[this.document.payments.length - 1].payment += diference
            }

            // if (this.document.payments.length) {
            //     const payment = this.totalDebt + this.totalPaid
            //     this.document.payments[0].payment = payment
            // } else {
            //     this.clickAddPayment()
            // }
        },

        async clickTo(format) {
            let url = `/sale-notes/get-pdf-format/${this.external_id}/`
            let generate = false
            if (format === 'ticket') { // 80mm
                url += 'ticket'
                generate = true
            }
            if (format === 'ticket_58') { // 58mm
                url += 'ticket_58'
                generate = true
            }
            if (format === 'ticket_50') { // 50mm
                url += 'ticket_50'
                generate = true
            }
            if (format === 'a4') { // A4
                url += 'a4'
                generate = true
            }
            if (format === 'a5') { // A5
                url += 'a5'
                generate = true
            }

            if (generate) {
                const response = await this.$http.get(url)
                if (response.data.data) {
                    if (format === 'ticket') {
                        this.print_ticket = response.data.data
                        // const url_preview = `https://docs.google.com/viewer?url=${this.print_ticket}?format=pdf`
                        const url_preview = `${this.print_ticket}`
                        window.open(url_preview, '_blank')
                    }
                    if (format === 'ticket_58') {
                        this.print_ticket_58 = response.data.data
                        const url_preview = `${this.print_ticket_58}`
                        window.open(url_preview, '_blank')
                    }
                    if (format === 'ticket_50') {
                        this.print_ticket_50 = response.data.data
                        const url_preview = `${this.print_ticket_50}`
                        window.open(url_preview, '_blank')
                    }
                    if (format === 'a4') {
                        this.print_a4 = response.data.data
                        const url_preview = `${this.print_a4}`
                        window.open(url_preview, '_blank')
                    }
                    if (format === 'a5') {
                        this.print_a5 = response.data.data
                        const url_preview = `${this.print_a5}`
                        window.open(url_preview, '_blank')
                    }
                }
            }
        }

    },
};
</script>

<style>
    .table-pending > th,
    .table-pending > td {
        min-width: 120px;
    }
</style>


// WEBPACK FOOTER //
// modules/Hotel/Resources/assets/js/views/rooms/Checkout.vue